import styled from "styled-components";


export const StyledPopperWrapper = styled.div`
    z-index: 1000;
`;